export default __webpack_public_path__ + "static/media/chat_ban.b2301b54.svg";